var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
  return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var _a;
import { account } from './resources/account';
import { acknowledgement } from './resources/acknowledgement';
import { audioVisitation } from './resources/audioVisitation';
import { auth } from './resources/auth';
import { block } from './resources/block';
import { cdr } from './resources/cdr';
import { commissary } from './resources/commissary';
import { condition } from './resources/conditions';
import { configuration } from './resources/configuration';
import { email } from './resources/email';
import { eventNotification } from './resources/eventNotification';
import { facility } from './resources/facility';
import { facilityUser } from './resources/facilityUser';
import { housingUnit } from './resources/housingUnit';
import { inmateAccount } from './resources/inmateAccount';
import { inmateContact } from './resources/inmateContact';
import { inmateDevice } from './resources/inmateDevice';
import { inmateNotification } from './resources/inmateNotification';
import { inmatePostalMail } from './resources/inmatePostalMail';
import { inmateRequest } from './resources/inmateRequest';
import { inmates } from './resources/inmates';
import { itds } from './resources/itds';
import { location as locationResource } from './resources/location';
import { mobileDevice } from './resources/mobileDevice';
import { outsideParty } from './resources/outsideParty';
import { personSearch } from './resources/personSearch';
import { phoneCard } from './resources/phoneCard';
import { privateNumber } from './resources/privateNumber';
import { recordingBatch } from './resources/recordingBatch';
import { referenceMaterial } from './resources/referenceMaterial';
import { reports } from './resources/reports';
import { station } from './resources/station';
import { textMessage } from './resources/textMessage';
import { visitation } from './resources/visitation';
import { visitationPending } from './resources/visitationPending';
import { voicemail } from './resources/voicemail';
import { website } from './resources/website';
import ApiService from './services/api_service';
import config from './services/config';
import connectServerService from './services/connect_server_service';
var siteApi = new ApiService(config.api.url, 'site');
var centralApi = new ApiService(((_a = config.centralApi) === null || _a === void 0 ? void 0 : _a.url) || 'https://api.reliancetelephone.com', 'central');
var accessToken = null;
var resources = {
  setToken: function setToken(token) {
    // This method will be called from the auth reducer when either site or central API refresh the token, so the other instance will get it as well
    accessToken = token;
    siteApi.setToken(accessToken);
    centralApi.setToken(accessToken);
    // Connect to Connect Server if configured
    if (token && config.connectServer && config.connectServer.url) {
      connectServerService.open();
    }
  },
  getToken: function getToken() {
    return __awaiter(void 0, void 0, Promise, function () {
      return __generator(this, function (_a) {
        if (siteApi.isTokenExpired()) {
          return [2 /*return*/, siteApi.refreshToken()];
        }
        return [2 /*return*/, Promise.resolve(accessToken)];
      });
    });
  },
  getCentralGetResource: function getCentralGetResource(url) {
    return function (params) {
      return centralApi.get(url, {
        params: params
      });
    };
  },
  getSiteGetResource: function getSiteGetResource(url) {
    return function (params) {
      return siteApi.get(url, {
        params: params
      });
    };
  },
  account: account(centralApi),
  acknowledgement: acknowledgement(centralApi),
  audioVisitation: audioVisitation(siteApi),
  auth: auth(siteApi),
  block: block(centralApi),
  condition: condition(centralApi),
  cdr: cdr(siteApi, function () {
    return accessToken;
  }),
  commissary: commissary(centralApi, function () {
    return accessToken;
  }),
  configuration: configuration(siteApi),
  email: email(centralApi),
  eventNotification: eventNotification(centralApi),
  facility: facility(centralApi),
  facilityUser: facilityUser(centralApi),
  housingUnit: housingUnit(centralApi),
  inmateAccount: inmateAccount(siteApi, centralApi),
  inmateContact: inmateContact(siteApi, centralApi),
  inmateDevice: inmateDevice(siteApi),
  inmateNotification: inmateNotification(centralApi),
  inmatePostalMail: inmatePostalMail(centralApi),
  inmateRequest: inmateRequest(centralApi, function () {
    return accessToken;
  }),
  inmates: inmates(siteApi, centralApi, function () {
    return accessToken;
  }),
  itds: itds(siteApi),
  location: locationResource(centralApi),
  mobileDevice: mobileDevice(siteApi),
  outsideParty: outsideParty(siteApi, function () {
    return accessToken;
  }),
  personSearch: personSearch(centralApi),
  phoneCard: phoneCard(centralApi),
  privateNumber: privateNumber(centralApi),
  recordingBatch: recordingBatch(siteApi, function () {
    return accessToken;
  }),
  referenceMaterial: referenceMaterial(siteApi, function () {
    return accessToken;
  }),
  reports: reports(centralApi, function () {
    return accessToken;
  }),
  station: station(siteApi),
  textMessage: textMessage(siteApi, centralApi, function () {
    return accessToken;
  }),
  visitation: visitation(siteApi, function () {
    return accessToken;
  }),
  visitationPending: visitationPending(siteApi),
  voicemail: voicemail(siteApi, function () {
    return accessToken;
  }),
  website: website(siteApi)
};
export default resources;